import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledOutlineButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_DISABLE_BUTTONS, EDGE_DISABLE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeDisabledOutlineButtons = () => {
    return (
        <Card>
          <CommonCardHeader title={DisabledOutlineButton} span={EDGE_DISABLE_BUTTONS} />
          <CardBody className="btn-showcase">
            <Btn disabled outline color="primary" className="btn-pill">{Disabled}</Btn>
            {EDGE_DISABLE_BUTTONS_LIST.map((data, index) => (
              <CommonEdgeButton key={index} item={data} disabled outline/>
            ))}
          </CardBody>
        </Card>
      );
};

export default EdgeDisabledOutlineButtons;
